import React from 'react';
import { Body, Label } from '@sato/components';

import { IWidget, ParsedEntry } from '@/contentful/types';

import { CUSTOMER_SERVICE } from '@constants';
import { useApartmentProperties } from '@hooks/useApartmentProperties';
import { useCustomTranslations } from '@hooks/useCustomTranslations';

export const AcuteContactInformation = ({
  data,
}: {
  data: ParsedEntry<IWidget>;
}) => {
  const { t } = useCustomTranslations(data.customTranslations);
  const { maintenanceCompany } = useApartmentProperties();

  return (
    <div className="flex flex-col gap-3">
      <Label>{t('customerServiceTitle')}</Label>

      <div>
        <Body>{CUSTOMER_SERVICE.PHONE_SIMPLE}</Body>
        <Body>{t('customerServiceOpenHours')}</Body>
      </div>

      {maintenanceCompany && (
        <div className="flex flex-col gap-3">
          <Body>{t('otherTimes')}:</Body>

          <Label component="span">{maintenanceCompany?.name}</Label>

          <div>
            <Body>{t('maintenance24h')}</Body>
            {maintenanceCompany?.phoneHotline}
          </div>
        </div>
      )}
    </div>
  );
};
